<article class="lum-c-consumption-export lum-page lum-page--full-height lum-page__card">
  <header class="lum-page-header">
    <div class="lum-page-header__heading-group">
      <h2 class="lum-page-header__heading">Consumption Transactions Export</h2>
    </div>
  </header>

  <div class="lum-page-content">
    <div class="lum-c-consumption-export__content">
      <div class="lum-c-consumption-export__info">
        <p>
          This export will download consumption transaction data from your account, <strong>grouped by day then by SKU</strong>.
          For sales transactions, kit items will be broken down into their component parts. A product type of "KIT" will be used for kit items sold.
        </p>
        <h4>Transaction Types Included</h4>
        <ul>
          <li>Sales transactions (direct product sales and kit component consumption)</li>
          <li>Assembly orders (component consumption during assembly)</li>
          <li>Disassembly orders (product consumption during disassembly)</li>
          <li>Inventory adjustments (negative adjustments that reduce stock)</li>
        </ul>
        
        <h4>Export Columns</h4>
        <p>The exported file will contain the following columns:</p>
        <ul class="lum-c-consumption-export__columns-list">
          <li><strong>Date:</strong> The transaction date (YYYY-MM-DD format)</li>
          <li><strong>Product ID:</strong> Internal Luminous product unique identifier</li>
          <li><strong>Product SKU:</strong> Master SKU of the product</li>
          <li><strong>Product Name:</strong> Name of the product</li>
          <li><strong>Product Type:</strong> Type of product (PRODUCT or KIT)</li>
          <li><strong>Quantity:</strong> Total quantity consumed for the product on the transaction date</li>
        </ul>

        <p>
          <strong>Date Filters:</strong> Use the start and end date filters to export transactions within a specific date range. 
          Leave empty to export all historical data. If the export takes too long, or you get an error, try reducing the date range.
        </p>
      </div>

      <div class="lum-c-consumption-export__controls">
        <div class="lum-c-consumption-export__date-filters">
          <div class="lum-c-consumption-export__filter">
            <div class="lum-label lum-c-consumption-export__filter-label">
              Start Date
            </div>
            <div class="lum-c-consumption-export__filter-input-wrapper">
              <input
                type="text"
                class="lum-input lum-c-consumption-export__filter-control"
                placeholder="Select Start Date"
                size="12"
                matInput
                [(ngModel)]="selectedStartDate"
                [matDatepicker]="startDatePicker"
                (dateChange)="onStartDateChange($event)"
              />
              <mat-datepicker-toggle
                class="lum-c-consumption-export__filter-affix"
                [for]="startDatePicker"
              ></mat-datepicker-toggle>
            </div>
            <mat-datepicker #startDatePicker></mat-datepicker>
          </div>
          <div class="lum-c-consumption-export__filter">
            <div class="lum-label lum-c-consumption-export__filter-label">
              End Date
            </div>
            <div class="lum-c-consumption-export__filter-input-wrapper">
              <input
                type="text"
                class="lum-input lum-c-consumption-export__filter-control"
                placeholder="Select End Date"
                size="12"
                matInput
                [(ngModel)]="selectedEndDate"
                [matDatepicker]="endDatePicker"
                (dateChange)="onEndDateChange($event)"
              />
              <mat-datepicker-toggle
                class="lum-c-consumption-export__filter-affix"
                [for]="endDatePicker"
              ></mat-datepicker-toggle>
            </div>
            <mat-datepicker #endDatePicker></mat-datepicker>
          </div>
        </div>
        
        <div class="lum-c-consumption-export__transaction-types">
          <div class="lum-c-consumption-export__section-label">Transaction Types to Include:</div>
          <div class="lum-c-consumption-export__checkboxes">
            <mat-checkbox [(ngModel)]="transactionTypes.sale">
              Sales Transactions
            </mat-checkbox>
            <mat-checkbox [(ngModel)]="transactionTypes.assembly">
              Assembly Orders
            </mat-checkbox>
            <mat-checkbox [(ngModel)]="transactionTypes.disassembly">
              Disassembly Orders
            </mat-checkbox>
            <mat-checkbox [(ngModel)]="transactionTypes.adjustment">
              Inventory Adjustments
            </mat-checkbox>
          </div>
        </div>
        
        <div class="lum-c-consumption-export__format-row">
          <div class="lum-c-consumption-export__format-selector">
            <mat-form-field appearance="outline">
              <mat-label>Export Format</mat-label>
              <mat-select [(value)]="selectedFormat">
                <mat-option value="xlsx">Excel (.xlsx)</mat-option>
                <mat-option value="csv">CSV (.csv)</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="lum-c-consumption-export__action">
          <button
            type="button"
            class="lum-button lum-button--large"
            mat-button
            [disabled]="isExporting || !hasSelectedTransactionTypes"
            (click)="exportConsumptionData()"
          >
            <lum-ui-icon
              color="#ffffff"
              width="12"
              height="12"
              class="mr-2"
              icon="download-button"
            ></lum-ui-icon>
            {{ isExporting ? 'Preparing Export...' : 'Export Consumption Data' }}
          </button>
          <mat-spinner
            *ngIf="isExporting"
            [diameter]="20"
            class="ml-2"
          ></mat-spinner>
        </div>
      </div>
    </div>
  </div>
</article> 